import FastAPIClient from "./services/apiClient";
import config from "./config";
import { v4 as uuidv4 } from "uuid";
export const client = new FastAPIClient()

// Local mapping for currency codes to symbols
export const currencyCodeToSymbolMap = {
    "NGN": "₦",
    "USD": "$",
    "EUR": "€",
    "GBP": "£",
    "JPY": "¥",
    "CAD": "C$",
    "AUD": "A$",
    "CHF": "CHF",
    "CNY": "¥",
    "INR": "₹",
    "BRL": "R$",
    "RUB": "₽",
    // Add more as needed
};

/**
 * Formats numbers with thousands separators and fixed decimals.
 * @param {number|string} amount - The value to format
 * @param {number} decimals - Number of decimal places (default 2)
 * @param {string} currency - Optional currency symbol (e.g., '₦', '$')
 * @returns {string} Formatted string (e.g., "₦ 1,250,500.00")
 */
export const formatCurrency = (amount, decimals = 2, currency = '', csmap = null) => {
    if (currency && csmap) {
        currency = csmap[currency];
    }
    if (amount === null || amount === undefined || isNaN(amount)) {
        return `${currency ? currency : ''}0.${'0'.repeat(decimals)}`;
    }

    const numericValue = typeof amount === 'string' ? parseFloat(amount) : amount;

    // Uses the browser's native Intl.NumberFormat for high performance and local accuracy
    const formattedNumber = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(numericValue);

    return currency ? `${currency}${formattedNumber}` : formattedNumber;
};

export const generateUniquePoNumber = () => {
    // 1. Use uuidv4() instead of crypto.randomUUID()
    // 2. uuidv4() returns a standard UUID string like:
    //    'a1b2c3d4-e5f6-7890-1234-567890abcdef'

    // The rest of your logic remains the same to format it
    // into a 15-character, hyphen-free, uppercase string.
    return uuidv4()
        .replace(/-/g, '') // Removes all hyphens: 'a1b2c3d4e5f678901234567890abcdef'
        .toUpperCase()      // Converts to uppercase
        .substring(0, 15);  // Takes the first 15 characters
};

// export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
export const capitalize = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');

export const API_BASE_PATH = `${config.apiBasePath}/api/v1`
export const API_ROOT_PATH = `${config.apiBasePath}`

export const getFullName = (user) => {
    if (!user) return 'User'
    const parts = [
        user.first_name || '',
        user.middle_name || '',
        user.last_name || ''
    ].filter(Boolean);

    return parts.length > 0 ? parts.join(' ') : 'User';
}

export const checkpointOrganizations = async (username) => {
    const data = await client.fetchData(`/auth/search-orgs?email=${encodeURIComponent(username)}`)
    return data
}

export const fetchParentWardProfile = async () => {
    const data = await client.fetchData('/users/parent-ward-profile')
    return data
}

export const fetchTotalReceivableBalance = async (payload) => {
    const data = await client.postData('/accounting/customer-total-receivable-balance', payload)
    return data
}

export const fetchCustomerDepositBalance = async (customer_id) => {
    const data = await client.fetchData(`/sales/fetch-students-deposit/${customer_id}`)
    return data
}

export const fetchInventoryForStoreSales = async (payload) => {
    const data = await client.postData('/inventory/inventory-for-sales',payload)
    return data
}

export const fetchServicesForStoreSale = async (payload) => {
    const data = await client.postData('/inventory/services-for-sales',payload)
    return data
}

export const fetchPKForStore = async(payload) => {
    const data = await client.postData('/store/fetch-attr', payload);
    return data;
}

export const fetchDiscountRules = async (payload) => {
    const data = await client.postData('/accounting/discounts', payload)
    return data
}

export const fetchInvoicesHistory = async (payload) => {
    const data = await client.postData('/accounting/customer-total-receivable-balance-and-orders', payload)
    return data
}

export const fetchPaymentsHistory = async () => {
    const data = await client.fetchData('/school/portal-transactions')
    return data
}